import React from 'react';
import { Link } from 'react-router-dom';
import { usePublicLanguage } from '../contexts/PublicLanguageContext';
import { emphasize, labelled } from '../utils/emphasize';
import './PublicAbout.css';

const PublicAbout: React.FC = () => {
  const { t } = usePublicLanguage();
  const a = t.about;

  return (
    <div className="public-about-container">
      {/* Header Section */}
      <section className="about-header">
        <div className="about-header-content">
          <div className="about-logo-placeholder">
            <div className="logo-box">
              <img src="/logo192.png" alt="Yarnboard" className="brand-logo-img" />
            </div>
          </div>
          <h1>{a.title}</h1>
          <p className="about-tagline">{a.tagline}</p>
        </div>
      </section>

      {/* Story Section */}
      <section className="about-story">
        <div className="about-content">
          <h2>{a.storyTitle}</h2>
          <p>{a.storyP1}</p>
          <p>{a.storyP2}</p>
        </div>
      </section>

      {/* Technology Section */}
      <section className="about-tech">
        <div className="about-content">
          <h2>{a.techTitle}</h2>
          <p>{a.techIntro}</p>
          {/* Each feature is one translated "Label: description" string; labelled()
              bolds the label without discarding either half of the translation. */}
          <ul className="tech-list">
            <li>{labelled(a.techFeatures.ocr)}</li>
            <li>{labelled(a.techFeatures.aiTagging)}</li>
            <li>{labelled(a.techFeatures.videoSummaries)}</li>
            <li>{labelled(a.techFeatures.mindMapping)}</li>
            <li>{labelled(a.techFeatures.search)}</li>
          </ul>
        </div>
      </section>

      {/* Privacy Section */}
      <section className="about-privacy">
        <div className="about-content">
          <h2>{a.privacyTitle}</h2>

          <div className="privacy-section">
            <h3>{a.sections.infoCollect}</h3>
            <p>{emphasize(a.privPersonalTitle)}</p>
            <ul>
              <li>{a.privPersonal1}</li>
              <li>{a.privPersonal2}</li>
              <li>{a.privPersonal3}</li>
              <li>{a.privPersonal4}</li>
            </ul>
            <p>{emphasize(a.privAutoTitle)}</p>
            <ul>
              <li>{a.privAuto1}</li>
              <li>{a.privAuto2}</li>
              <li>{a.privAuto3}</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h3>{a.sections.howWeUse}</h3>
            <ul>
              <li>{emphasize(a.privUse1)}</li>
              <li>{emphasize(a.privUse2)}</li>
              <li>{emphasize(a.privUse3)}</li>
              <li>{emphasize(a.privUse4)}</li>
              <li>{emphasize(a.privUse5)}</li>
              <li>{emphasize(a.privUse6)}</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h3>{a.sections.dataSecurity}</h3>
            <p>{a.privSecurityBody}</p>
            <p>{emphasize(a.privSecurityThirdParty)}</p>
          </div>

          <div className="privacy-section">
            <h3>{a.sections.dataSharing}</h3>
            <p>{a.privSharingIntro}</p>
            <ul>
              <li>{emphasize(a.privSharing1)}</li>
              <li>{emphasize(a.privSharing2)}</li>
              <li>{emphasize(a.privSharing3)}</li>
              <li>{emphasize(a.privSharing4)}</li>
              <li>{emphasize(a.privSharing5)}</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h3>{a.sections.yourRights}</h3>
            <p>{emphasize(a.privAccessTitle)}</p>
            <ul>
              <li>{a.privAccess1}</li>
              <li>{a.privAccess2}</li>
              <li>{a.privAccess3}</li>
              <li>{a.privAccess4}</li>
            </ul>
            <p>{emphasize(a.privCommTitle)}</p>
            <ul>
              <li>{a.privComm1}</li>
              <li>{a.privComm2}</li>
            </ul>
            <p>{emphasize(a.privRegionalTitle)}</p>
            <ul>
              <li>{emphasize(a.privRegional1)}</li>
              <li>{emphasize(a.privRegional2)}</li>
              <li>{emphasize(a.privRegional3)}</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h3>{a.sections.dataRetention}</h3>
            <p>{a.privRetentionBody}</p>
          </div>

          <div className="privacy-section">
            <h3>{a.sections.children}</h3>
            <p>{a.privChildrenBody}</p>
          </div>

          <div className="privacy-section">
            <h3>{a.sections.international}</h3>
            <p>{a.privInternationalBody}</p>
          </div>

          <div className="privacy-section">
            <h3>{a.sections.changes}</h3>
            <p>{a.privChangesBody}</p>
          </div>

          <div className="privacy-section">
            <h3>{a.sections.contact}</h3>
            <p>{a.privContactIntro}</p>
            <ul>
              <li>{emphasize(a.privContactEmail)}</li>
              <li>{emphasize(a.privContactLocation)}</li>
            </ul>
            <p className="privacy-effective">
              <strong>{a.effectiveDate}</strong>
            </p>
            <p className="terms-link-section">
              {a.termsLinkText} <Link to="/terms" className="terms-link">{t.footer.terms}</Link>.
            </p>
          </div>
        </div>
      </section>

      {/* Footer Section */}
      <section className="about-footer">
        <div className="about-content">
          <p>{t.footer.madeWith}</p>
          <p className="pura-vida">{a.puraVida}</p>
        </div>
      </section>
    </div>
  );
};

export default PublicAbout;
